export default __webpack_public_path__ + "static/2_showman-powerbomb-2-20d3457ecce47679cb68c9e0fa584a95.png";